import type { ReactNode } from "react";

import { Video } from "lucide-react";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

// Videos have no generated thumbnail, so small spots show the video's first frame instead.
export function VideoFrame({
  className,
  fallback,
  title,
  url,
}: {
  className?: string;
  fallback?: ReactNode;
  title: string;
  url: string;
}) {
  const [hasFailed, setHasFailed] = useState(false);

  if (hasFailed) {
    return (
      fallback ?? (
        <div
          className={twMerge(
            "flex items-center justify-center bg-bg-secondary text-fg-quaternary",
            className,
          )}
        >
          <Video className="size-5" />
        </div>
      )
    );
  }

  return (
    <video
      aria-label={`Video for ${title}`}
      className={className}
      muted
      onError={() => setHasFailed(true)}
      playsInline
      preload="metadata"
      src={`${url}#t=0.1`}
    />
  );
}
